import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

@Component({
    mixins: [ProjectMixin],
})
export default class FABComponent extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop() route!: string

    get disabled() {
        return this.$route.name == this.route
    }
}
